import {ITableResultData} from "@/containers/E4ImpactProjects/resources/config-schema"

const transformData = [
    {
        name: 'Family & friends',
        value: 'Item 1',
        keyQuestion: 'question17', 
    },
    {
        name: 'Business Angels',
        value: 'Item 2',
        keyQuestion: 'question22',
    },
    {
        name: 'Crowdfunding',
        value: 'Item 3',
        keyQuestion: 'question27',
    },
    {
        name: 'Incubators and Accelerators',
        value: 'Item 4',
        keyQuestion: 'question32',
    },
    {
        name: 'NGO’s loans',
        value: 'Item 5',
        keyQuestion: 'question38',
    },
    {
        name: 'NGO’s grants',
        value: 'Item 6',
        keyQuestion: 'question43',
    },
    {
        name: 'Public subsidies',
        value: 'Item 7',
        keyQuestion: 'question48',
    },
    {
        name: 'Public grants',
        value: 'Item 8',
        keyQuestion: 'question53',
    },
    {
        name: 'Venture capital',
        value: 'Item 9',
        keyQuestion: 'question58',
    },
    {
        name: 'Microfinance',
        value: 'Item 10',
        keyQuestion: 'question63',
    },
    {
        name: 'Financial institutions (banks)',
        value: 'Item 11',
        keyQuestion: 'question68',
    },
    {
        name: 'Other',
        value: 'other',
        keyQuestion: 'question73',
    },
];

const columns = [
    {
        headerName: '',
        field: 'name',
        flex: 2
    },
    {
        headerName: 'Amount',
        field: 'amount',
        flex: 1
    },
    {
        headerName: 'Currency',
        field: 'currency',
        flex: 1
    },
];

/**
 * Survey: PROJECT- FINAL IMPACT
 * Question: What is the amount of funds requested from your family and friends?
 * 
 * == final
 * question17
 * question22
 * question27
 * question32
 * question38
 * question43
 * question48
 * question53
 * question58
 * question63
 * question68
 * question73
 * 
 * prefix currency: _financial_need_currency
 * prefix value: _financial_need_value
 * 
 * @param props 
 * @returns 
 */
export const averageAmountOfFundsRequestedPerTypeOfFundsTableCalculation = (props: any): ITableResultData => {
    const calculateSum = (key: string) => {
        const count = props.finalSubmissions
            .filter((submission: any) => 
                submission[`${key}_financial_need_value`] &&
                submission[`${key}_financial_need_currency`] === 'USD'
            );
        const sum = count.reduce((acc: number, submission: any) => acc + submission[`${key}_financial_need_value`], 0);

        return (sum / count.length) || 0;
    }
    
    const rows = transformData.map(
        ({name, keyQuestion}, index) => ({
            id: index,
            name,
            amount: calculateSum(keyQuestion),
            currency: 'USD',
        })
    );
    
    return {columns, rows}
}